export function roundDateToNearestMinutes(
  timestamp: Date | string | number,
  minutes: number
) {
  const ms = minutes * 60 * 1000;
  const date = new Date(timestamp);
  return new Date(Math.round(date.getTime() / ms) * ms);
}

export const isBelowOrUnset = (value: number | undefined, max: number) => {
  return value === undefined || value < max;
};

export interface Rules<T> {
  $eq?: T;
  $neq?: T;
  $in?: T[];
  $nin?: T[];
}

const condition_map = {
  $eq: (a: any, b: any) => a === b,
  $neq: (a: any, b: any) => a !== b,
  $in: (a: any, b: any) => b.some((v: any) => String(v) === a),
  $nin: (a: any, b: any) => !b.some((v: any) => String(v) === a)
} satisfies {
  [k in keyof Rules<any>]: (a: any, b: any) => boolean;
};

export function isResultFiltered<T>(
  result: T,
  conditions: Partial<{
    [k in keyof T]: Rules<T[k]>;
  }>
): boolean {
  for (const property in conditions) {
    const rule = conditions[property];
    if (!rule) {
      continue;
    }

    const property_value = String(result[property]);

    return Object.keys(rule).some(rule_key => {
      const key = rule_key as keyof Rules<any>;
      const rule_value = rule[key];
      return condition_map[key](property_value, rule_value);
    });
  }
  return false;
}
